import { isRejectedWithValue } from "@reduxjs/toolkit";
import { apiUrl, campaignNavigatorUrl } from "../constants";
import { logoutApiUrl } from "../constants";
import httpClient from "./http_client";

class SegmenterSectionAPIService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl;
    this.logoutApiUrl = logoutApiUrl;
  }

  async fetchClusterData(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/cluster_summary`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }
  async fetchChatResponse(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/chat`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  //   const fetchChatResponse = async (conversation) => {
  //   try {
  //     const response = await fetch(`${apiUrl}/chat`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         conversation: conversation,
  //         cluster_output_string: clusterOutputString,
  //         input_file: importFileName,
  //         token: auth?.user?.access_token,
  //       }),
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       return data.conversation[data.conversation.length - 1].message;
  //     }
  //     throw new Error("Failed to fetch response");
  //   } catch (error) {
  //     console.error(error);
  //     return "Error fetching response";
  //   }
  // };

  async fetchChartResponse2(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/aggregate_plot_data`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async fetchImportFiles(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/input_file_list`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async exportFileApi(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/save_cluster_summary`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async exportAutoClusterFileFromS3Api(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/upload_cluster_input_s3`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async exportAutoClusterFileApi(params) {
    const { file, s3Key } = params || {};
    if (!(file instanceof File || file instanceof Blob)) {
      return isRejectedWithValue({ message: 'file must be a File or Blob', code: 'ERR_INVALID_ARG' });
    }

    const formData = new FormData();

    if (!s3Key)
      formData.append('file', file, file ? file.name : 'upload.csv');
    else
      formData.append('file', null);
    formData.append('s3Key', s3Key);


    try {
      const response = await httpClient.post(
        `${this.apiUrl}/upload_ac_input_data`,
        formData,
        {
          transformRequest: [(data) => data],
        }
      );

      return response?.data;
    } catch (err) {

      const payload = err?.response?.data ?? { message: err?.message ?? 'Unknown error' };
      throw payload;
    }
  }

  async fetchRAGFiles(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/list_seg_kb_files`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async exportRAGFileApi(params) {
    const { file } = params || {};

    for (let i = 0; i < file.length; i++) {
      if (!(file[i] instanceof File || file[i] instanceof Blob)) {
        return isRejectedWithValue({ message: 'file must be a File or Blob', code: 'ERR_INVALID_ARG' });
      }
    }

    const formData = new FormData();

    for (let i = 0; i < file.length; i++) {
      formData.append('files', file[i], file[i].name);
    }

    const uploadRes = await fetch(`${campaignNavigatorUrl}api/v1/amai/upload_to_s3_multiple`, {
      method: "POST",
      body: formData
    });

    const uploadData = await uploadRes.json();
    //if (!uploadRes.ok) throw uploadData;

    try {
      const response = await httpClient.post(
        `${this.apiUrl}/upload_kb_input_files`, uploadData?.data
      );

      return response?.data;
    } catch (err) {

      const payload = err?.response?.data ?? { message: err?.message ?? 'Unknown error' };
      throw payload;
    }
  }

  async deleteRAGFileApi(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/delete_rag_file`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async exportClusterFileApi(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/cluster_data_export`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async syncRAGFileApi(params) {
    try {
      const response = await httpClient.post(`${this.apiUrl}/sync_uploaded_kb_files`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async fetchLogoutApi(params) {
    try {
      const response = await httpClient.post(`${this.logoutApiUrl}/logout`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

  async fetchSummarizedChatDownloadFileApi(params) {
    try {
      const response = await httpClient.post(
        `${this.apiUrl}/download_conversation_summary_pdf`,
        params,
        {
          responseType: "json",
        });
      return response?.data;
    } catch (err) {

      const payload = err?.response?.data ?? { message: err?.message ?? 'Unknown error' };
      throw payload;
    }
  }

  async pushToS3(params) {

    // const { file } = params || {};
    // if (!(file instanceof File || file instanceof Blob)) {
    //   return isRejectedWithValue({ message: 'file must be a File or Blob', code: 'ERR_INVALID_ARG' });
    // }

    // const formData = new FormData();
    // formData.append('file', file, file.name || 'upload.pdf');

    // try {
    //   const response = await httpClient.post(
    //     `${this.apiUrl}/download_campaign_as_pdf`,
    //     formData
    //   );

    //   return response?.data;
    // } catch (err) {

    //   const payload = err?.response?.data ?? { message: err?.message ?? 'Unknown error' };
    //   throw payload;
    // }

    try {
      const response = await httpClient.post(`${this.apiUrl}/download_campaign_as_pdf`, params);
      return response['data'];
    } catch (error) {
      return true
    }
  }

}

const segmenterSectionAPIService = new SegmenterSectionAPIService(apiUrl);
export default segmenterSectionAPIService;
